import { checkBit } from '../../Utils/Functions';
import  './DmStatus.css';

export default function DmStatus({status, islink}) {

    const forward=checkBit(status, 6);
    const revers=checkBit(status, 4);
    const nowater=checkBit(status, 3);
    const local_mode=checkBit(status, 0);

    let isDmStatus='';
    const hint='(Запущена по месту)';

    if (islink==='Offline') {isDmStatus= "Нет данных"} 
    else{
    if (forward && !nowater) isDmStatus="Движение вперед c водой";
    if (revers && !nowater) isDmStatus="Движение назад c водой";
    if (forward && nowater) isDmStatus="Движение вперед без воды";
    if (revers && nowater) isDmStatus="Движение назад без воды";
    if (!forward && !revers)  isDmStatus="Остановлена"}
    
    return(
        <>
        <div className='cardInfoStateDm'> 
            <span>{isDmStatus}</span>
            {local_mode && (islink==='Online') &&  <span className='cardInfoStateDm-hint'>{hint}</span>}
        </div>
        </>
    )
}